import { render, staticRenderFns } from "./Five.vue?vue&type=template&id=33dd973c&scoped=true&"
import script from "./Five.vue?vue&type=script&lang=js&"
export * from "./Five.vue?vue&type=script&lang=js&"
import style0 from "./Five.vue?vue&type=style&index=0&id=33dd973c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dd973c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VContainer,VRadio,VRadioGroup})
